import { render } from "./SwitchComponent.vue?vue&type=template&id=52d4a353&scoped=true&ts=true&lang=pug"
import script from "./SwitchComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SwitchComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SwitchComponent.vue?vue&type=style&index=0&id=52d4a353&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d4a353"]])

export default __exports__